import { useI18n } from '@change-corgi/core-react/i18n';

import { InfoTooltip } from '#src/app/shared/components/tooltips';

import { SignersText } from '../SignersText';

export const SignersTooltip: React.FC<{
	constituentCount: number;
	constituentCountLocalized: string;
	isFormer: boolean;
	onTooltipClick: () => void;
}> = ({ constituentCount, constituentCountLocalized, isFormer, onTooltipClick }) => {
	const { translate } = useI18n();
	return (
		<InfoTooltip
			aria-label={translate('corgi.petition_gamma.decision_makers_v2.constituency_tooltip')}
			data-qa="dm-info-tooltip"
			onClick={onTooltipClick}
		>
			<SignersText
				constituentCount={constituentCount}
				constituentCountLocalized={constituentCountLocalized}
				isFormer={isFormer}
			/>
		</InfoTooltip>
	);
};
